export default "__VITE_ASSET__B9sBRDS0__"